export default "__VITE_ASSET__21ca12b3__"